import { render, staticRenderFns } from "./vipMemberData.vue?vue&type=template&id=2b2eda64&scoped=true"
import script from "./vipMemberData.vue?vue&type=script&lang=js"
export * from "./vipMemberData.vue?vue&type=script&lang=js"
import style0 from "./vipMemberData.vue?vue&type=style&index=0&id=2b2eda64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2eda64",
  null
  
)

export default component.exports